import { render, staticRenderFns } from "./manage-searches.vue?vue&type=template&id=07fa05fa&scoped=true"
import script from "./manage-searches.vue?vue&type=script&lang=js"
export * from "./manage-searches.vue?vue&type=script&lang=js"
import style0 from "./manage-searches.vue?vue&type=style&index=0&id=07fa05fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa05fa",
  null
  
)

export default component.exports